import React, { useEffect, useState } from 'react';
import { getPremiumMe, PremiumMeResponse, ToolKey } from '../../../api/premiumService';
import Loader from '../../../components/Loader';
import PremiumBanner from '../../../components/Premium/Unlocked/PremiumBanner';
import PremiumToolsGrid from '../../../components/Premium/PremiumToolsGrid';
import PremiumHistory from '../../../components/Premium/PremiumHistory';

const PremiumActive: React.FC = () => {
  const [data, setData] = useState<PremiumMeResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  // filtros (estado en el contenedor para poder guardarlos/restaurarlos si hiciera falta)
  const [toolFilter, setToolFilter] = useState<ToolKey | 'all'>('all');

  useEffect(() => {
    (async () => {
      try {
        const res = await getPremiumMe();
        setData(res);
      } catch (e: any) {
        setError(e?.message ?? 'error');
      }
    })();
  }, []);

  if (error) return <div className="p-6 text-red-600">{error}</div>;
  if (!data) return <div className="flex items-center justify-center h-screen"><Loader /></div>;

  return (
    <div className="mx-auto max-w-6xl">
      <PremiumBanner premium={data.premium} />
      <PremiumToolsGrid quotas={data.quotas} />
      <PremiumHistory
        history={data.history ?? []}
        toolFilter={toolFilter}
        setToolFilter={setToolFilter}
      />
    </div>
  );
};

export default PremiumActive;
